import { FORM_VALIDATED } from "./consts";
import * as stateReducer from './handleInputState';
const StateReducer = stateReducer.StateReducer;

/**
 * @param {{
 * input: any
 * inputRefName: string
 * validationMessage: string,
 * serverMessage: string
 * }} data
*/
export const InputFieldData = (data) => ({
    inputRefName: data.inputRefName,
    validationMessage: data.validationMessage,
    serverMessage: data.serverMessage,
    input: data.input,
    message: '',
    /**
     * @type HTMLInputElement | null
     */
    inputref: null,
    /**
     * @type {stateReducer.inputState}
     */
    state: { interactionState: 'not-interacted', validationState: 'valid' },
    init() {
        this.inputref = this.$refs[this.inputRefName];
        if (this.serverMessage !== '') {
            this.state = StateReducer(this.state, { type: 'server-error' });
            this.inputref.classList.toggle('input-touched', true);
            this.inputref.setCustomValidity(this.serverMessage);
            this.message = this.serverMessage;
        }

        this.$watch(FORM_VALIDATED, () => {
            this.state = StateReducer(this.state, {
                type: 'form-validated',
                validationState: this.inputref.checkValidity() ? 'valid' : 'invalid'
            });
        })

        this.inputref?.addEventListener('blur', () => {
            this.state = StateReducer(this.state, {
                type: 'blur',
                validationState: this.inputref.checkValidity() ? 'valid' : 'invalid'
            });
        })


        this.$watch('input', () => {
            if (this.serverMessage.trim().length > 0 && this.message === this.serverMessage) {
                this.inputref.setCustomValidity('');
            }
            this.state = StateReducer(this.state, {
                type: 'input',
                validationState: this.inputref.checkValidity() ? 'valid' : 'invalid'
            });
        })

        this.$watch('state',
            /**
             * @param {stateReducer.inputState} state 
             */
            (state) => {
                this.inputref.classList.toggle('input-touched',
                    state.interactionState === 'interacted'
                );

                if (this.state.interactionState === 'interacted' && this.state.validationState === 'invalid') {
                    this.message = this.validationMessage;
                    this.inputref.setAttribute('aria-invalid', 'true');
                } else {
                    this.message = '';
                    this.inputref.setAttribute('aria-invalid', 'false');
                }
            })
    },

})